import { render } from "./App.vue?vue&type=template&id=464d5751"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script